import React from 'react';

const EledoPendingIcon = (props) => <i className="icon-spinner2 rotating-icon" {...props}/>;

export default EledoPendingIcon;
